const initialize = (reader) => {
  if (reader.dataset.toolsReady) return;
  reader.dataset.toolsReady = 'true';
  const key = `reading:${location.pathname}`;
  let size = matchMedia('(max-width:749px)').matches ? 18 : 19;
  const output = reader.querySelector('[data-reading-size-output]');
  const smaller = reader.querySelector('[data-reading-size="smaller"]');
  const larger = reader.querySelector('[data-reading-size="larger"]');
  if (!output || !smaller || !larger) return;
  const applySize = () => {
    reader.style.setProperty('--sf-reading-size', `${size}px`);
    output.textContent = `${size}px`;
    smaller.disabled = size <= 16;
    larger.disabled = size >= 26;
  };
  try {
    const saved = Number(localStorage.getItem('reading:text-size'));
    if (saved >= 16 && saved <= 26) size = saved;
    const chapter = Number(localStorage.getItem(key));
    const resume = reader.querySelector('[data-reading-resume]');
    if (resume && chapter >= 1 && chapter <= 5) {
      resume.href = `#preview-chapter-${chapter}`;
      resume.textContent = `Resume chapter ${chapter}`;
      resume.hidden = false;
    }
  } catch { /* Reader controls remain usable when storage is unavailable. */ }
  applySize();
  for (const button of [smaller, larger]) button.addEventListener('click', () => {
    size = Math.max(16, Math.min(26, size + (button === smaller ? -1 : 1)));
    applySize();
    try { localStorage.setItem('reading:text-size', String(size)); } catch {}
  });
  const observer = new IntersectionObserver((entries) => {
    const visible = entries.filter(entry => entry.isIntersecting).sort((a,b) => a.boundingClientRect.top - b.boundingClientRect.top);
    if (!visible.length) return;
    const chapter = visible[0].target.id.replace('preview-chapter-', '');
    try { localStorage.setItem(key, chapter); } catch {}
  }, { rootMargin: '-15% 0px -55% 0px', threshold: 0 });
  reader.querySelectorAll('.night-reader__chapter').forEach(chapter => observer.observe(chapter));
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.contains(reader)) observer.disconnect();
  });
};
document.querySelectorAll('night-preview-reader').forEach(initialize);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('night-preview-reader').forEach(initialize));
